// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"river-portable-power-station_productcontent__FXlz_"};